import { render } from "./ChangeMobile.vue?vue&type=template&id=5ec02537&scoped=true"
import script from "./ChangeMobile.vue?vue&type=script&lang=ts"
export * from "./ChangeMobile.vue?vue&type=script&lang=ts"

import "./ChangeMobile.vue?vue&type=style&index=0&id=5ec02537&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5ec02537"

export default script